import { useEffect, useState } from "react";
import {
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { onHubEvent, startRealtimeHub } from "../../Services/realtimeHubService";
import NotificationsNoneSharpIcon from '@mui/icons-material/NotificationsNoneSharp';
import NotificationsToast from "../NotificationsToast";
import axios from "../../API/axios";
import { getUnreadNotificationCount } from "../../Services/apiService";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { transform } from "lodash";
import { ListRowSkeleton } from "@skeleton";
import { people, post } from "../../config/imagesLink";
import { useTranslation } from "react-i18next";
import { TOP_NOTIFICATION_SOUND_URL } from "../../config/staticAssets";
import "../Message/Message.css";

const TOP_NOTIFICATION_DROPDOWN_COUNT = 5;

const POST_NOTIFICATION_TYPES = [4, 5, 6, 7, 8, 9, 10, 11, 18, 24];
const JOB_NOTIFICATION_TYPES = [17, 19, 20, 21, 22, 23, 25, 26];

const getNotificationLink = (item) => {
  if (item?.type === 1) return `/Company/${item?.fromUserUid}`;
  if (item?.type === 2) return `/Message/${item?.fromUserUid}`;
  if (POST_NOTIFICATION_TYPES.includes(item?.type)) {
    return `/Post/${item?.refLinkId}`;
  }
  if (JOB_NOTIFICATION_TYPES.includes(item?.type)) {
    return `/JobDetail/${item?.refLinkId}`;
  }
  return `/User/${item?.fromUserUid}`;
};

export default function TopNotification({
  closeTooltip,
  notifiCount: notifiCountProp,
  setNotifiCount: setNotifiCountProp,
  isOpen,
  toggle,
}) {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();

  const [notifi, setNotifi] = useState([]);
  const [notifiCount, setNotifiCount] = useState(() => {
    const stored = localStorage.getItem("NotificationCountData");
    return stored != null && stored !== "" ? Number(stored) : 0;
  });

  const displayCount =
    notifiCountProp !== undefined && notifiCountProp !== null && notifiCountProp !== ""
      ? Number(notifiCountProp) || 0
      : Number(notifiCount) || 0;

  const applyCount = (count) => {
    if (count == null) return;
    setNotifiCount(count);
    setNotifiCountProp?.(count);
  };
  const [notificationData, setNoticationData] = useState({});
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(true);


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const language = localStorage.getItem("Lang");



  const NotificationList = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      // setLoading(true);
      await axios
        .post(`General/GetTop5Notifications`, data)
        
        .then((resData) => {
          console.log("resDataNew", resData);
          setNotifi(resData.data.responseData);
          setIsLoading(false);
          setIsError(false);

        });
    } catch (error) {
      // console.log("error", error);
      if (error.response.status === 404 || error.status === 404) {
        setIsLoading(false);
        
        setIsError(true);
      } else {
        console.log("error", error.response.status);
      }

      // setLoading(false);
    }
  };
  const ReadNotification = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios
        .post(`General/MarkNotificationAsRead?ID=${id}`, responseData)
        .then((res) => {
          NotificationList();
        });
    } catch (e) {
      console.log(e.response);
    }
  };
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);

  const NotificationCount = async ({ forceRefresh = false } = {}) => {
    try {
      const count = await getUnreadNotificationCount({ forceRefresh });
      if (count != null) {
        applyCount(count);
      }
    } catch (error) {
      // handle session expiry (401) gracefully: clear fetched flag and notify app
      if (error && error.response && error.response.status === 401) {
        try {
          localStorage.removeItem("NotificationCountFetched");
        } catch (e) {
          // ignore storage errors
        }
        // let the rest of the app handle session expiry (existing global handler)
        window.dispatchEvent(new Event("sessionExpired"));
      } else {
        // other errors are ignored here (preserve previous behavior)
        // if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        //   setUnauthorisedModal(true)
        // }
      }
    }
  };

  useEffect(() => {
    if (!sessionId) return undefined;

    NotificationCount({ forceRefresh: true });

    const handleUserLoggedIn = () => {
      NotificationCount({ forceRefresh: true });
    };

    const handleCountUpdated = (event) => {
      const count = event?.detail?.count;
      if (count != null) {
        applyCount(count);
      }
    };

    window.addEventListener("userLoggedIn", handleUserLoggedIn);
    window.addEventListener("notificationCountUpdated", handleCountUpdated);

    return () => {
      window.removeEventListener("userLoggedIn", handleUserLoggedIn);
      window.removeEventListener("notificationCountUpdated", handleCountUpdated);
    };
  }, [sessionId]);

  useEffect(() => {
    let cancelled = false;
    let unsubscribeNotification;

    const setupHub = async () => {
      try {
        await startRealtimeHub();
      } catch (e) {
        console.log("Connection failed: ", e);
        return;
      }

      if (cancelled) return;

      unsubscribeNotification = onHubEvent("RealTimeNotification", (notification) => {
        NotificationCount({ forceRefresh: true });

        const loggedInUserId = localStorage.getItem("CheckNotifyId");

        if (
          Array.isArray(notification.toUsers_Ids) &&
          notification.toUsers_Ids.includes(loggedInUserId) &&
          notification.fromUserId !== loggedInUserId
        ) {
          setTimeout(() => {
            const audio = new Audio(TOP_NOTIFICATION_SOUND_URL);
            audio.play().catch((err) => console.log("Audio play failed:", err));
            setShow(true);
            setNoticationData(notification);
          }, 3000);
        } else {
          console.log("Ignored self-notification");
        }
      });
    };

    setupHub();

    return () => {
      cancelled = true;
      unsubscribeNotification?.();
    };
  }, []);

  //************************Delete Post start  ************************//

  const [showDropdown, setShowDropdown] = useState(false);
  const [deleteId, setDeleteId] = useState(null);


  const [showD, setShowD] = useState(false);
  const handleDeleteClose = () => {
    setShowD(false);
  };

  const deleteNoti = async (event) => {
    event.preventDefault();
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios
        .post(`General/DeleteNotification?ID=${deleteId}`, responseData)

        .then((res) => {
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          NotificationList();
          NotificationCount({ forceRefresh: true });
          setShowD(!showD);
          // setNotificationList((prev) => prev.filter((item) => item.ntfctnId !== deleteId));
          // NotificationCount()
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show]);

  //************************Delete Post End  ************************//


  const formatNotificationTime = (time) => {
    const now = moment();
    const itemTime = moment.utc(time);
    const duration = moment.duration(now.diff(itemTime));

    const years = duration.years();
    const months = duration.months();
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    if (years > 0) {
      return `${years} ${t("Notifications.Year")}${years > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
    }
    if (months > 0) {
      return `${months} ${t("Notifications.Month")}${months > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
    }
    if (days > 0) {
      return `${days} ${t("Notifications.Day")}${days > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
    }
    if (hours > 0) {
      return `${hours} ${t("Notifications.Hour")}${hours > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
    }
    if (minutes > 0) {
      return `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
    }
    return t("Notifications.Just Now");
  };

  const renderNotificationRow = (item, index, isUnread) => {
    const avatarSrc =
      typeof item?.fromProfilPic === "string" && item.fromProfilPic.trim()
        ? item.fromProfilPic
        : people.DefaultProfile;

    return (
      <li
        className={`dropdown-menu-header top-notification-item${isUnread ? " unreadNotification" : ""}`}
        key={item?.ntfctnId || index}
      >
        <DropdownItem
          to={getNotificationLink(item)}
          onClick={
            isUnread
              ? () => {
                  ReadNotification(item?.ntfctnId);
                }
              : undefined
          }
          tag={Link}
          className="topnotification d-flex align-items-center"
        >
          <img
            src={avatarSrc}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = people.DefaultProfile;
            }}
            width={40}
            height={40}
            style={{ borderRadius: "50%" }}
            className="me-3 top-notification-avatar"
            alt=""
          />

          <div className="notification-text flex-grow-1">
            <div className="d-flex justify-content-between align-items-center">
              <div className="notification-message mb-0 d-flex align-items-center">
                <span>{item?.fromUserFname}</span>
              </div>
              <span className="side-text ms-0">
                {formatNotificationTime(item?.time)}
              </span>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <div className="mb-0 content-text me-2">
                <span>{item?.content}</span>
              </div>
              <DeleteOutlineSharpIcon
                className="material-symbols-sharp pointer delete-iconsymbols"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setDeleteId(item?.ntfctnId);
                  setShowD(true);
                  toggleDropdown();
                }}
              />
            </div>
          </div>
        </DropdownItem>
      </li>
    );
  };

  const renderNotificationItems = () => {
    const items = (notifi || []).slice(0, TOP_NOTIFICATION_DROPDOWN_COUNT);
    return (
      <div className="notificationscroller">
        {items.map((item, index) =>
          renderNotificationRow(item, index, item?.isView === false)
        )}
      </div>
    );
  };


  // useEffect(() => {
  //     // notificationList()
  //     // companynotificationList()
  // }, [loadList])

  const isControlled = typeof isOpen === "boolean" && typeof toggle === "function";

  useEffect(() => {
    if (isControlled && isOpen) {
      closeTooltip?.();
      NotificationList();
    }
  }, [isControlled, isOpen]);

  const dropdownMenu = (
    <DropdownMenu
      container="body"
      end
      flip={false}
      strategy="fixed"
      modifiers={[
        { name: "offset", options: { offset: [0, 8] } },
        {
          name: "preventOverflow",
          options: { padding: 12, boundary: "viewport", altAxis: true },
        },
      ]}
      tag="ul"
      className="dropdown-menu-media mt-0 notificationDropdown topmessages top-notifications-menu wlj-header-quick-panel"
      onMouseEnter={closeTooltip}
      onMouseLeave={closeTooltip}
    >
      <>
        <li className="dropdown-menu-header">
          <DropdownItem className="d-flex" tag="div" header>
            <h4 className="notification-title mb-0 me-auto">{t("Notifications.Notification")}</h4>
            <div className="badge badge-notificationCount">
              {displayCount} {t("Notifications.New")}
            </div>
          </DropdownItem>
        </li>

        {isLoading ? (
          <div className="notificationscroller">
            <ListRowSkeleton count={TOP_NOTIFICATION_DROPDOWN_COUNT} rowHeight={50} showAvatar />
          </div>
        ) : isError || notifi.length === 0 ? (
          <div className="notificationscroller text-center my-3">
            <img src={post.errorSmall} alt="Error" width={200} />
            <p className="mt-2">{t("Notifications.No notification found")}</p>
          </div>
        ) : (
          renderNotificationItems()
        )}
        <li className="dropdown-menu-footer">
          <Link to="/Notification" onClick={() => isControlled && toggle()}>
            <button
              type="button"
              className="wljPrimaryBtn d-flex align-items-center mt-2 mb-2 noti-btn"
            >
              {t("Notifications.View all notifications")}
            </button>
          </Link>
        </li>
      </>
    </DropdownMenu>
  );

  const dropdownToggle = (
    <DropdownToggle
      tag="button"
      type="button"
      className="nav-link notification-toggle"
      caret={false}
      onClick={() => closeTooltip?.()}
    >
      <NotificationsNoneSharpIcon className="material-symbols-sharp" />
      {displayCount > 0 ? (
        <Badge pill color="danger" className="badge-up notifictaionBadge">
          {displayCount > 99 ? "99+" : displayCount}
        </Badge>
      ) : null}
    </DropdownToggle>
  );

  return (
    <>
      <NotificationsToast
        id={Date.now()}
        show={show}
        data={notificationData}
        onClose={() => setShow(false)}
      />
      {isControlled ? (
        <Dropdown isOpen={isOpen} toggle={toggle} className="dropdown-notification">
          {dropdownToggle}
          {dropdownMenu}
        </Dropdown>
      ) : (
        <UncontrolledDropdown
          className="dropdown-notification"
          onToggle={(_e, open) => {
            if (open) {
              closeTooltip?.();
              NotificationList();
            }
          }}
        >
          {dropdownToggle}
          {dropdownMenu}
        </UncontrolledDropdown>
      )}
      {
        unauthorisedModal && (
          <div
            className="modal fade show postAdd"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                    <p className="text-center ad-p">
                      {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")} 
                    </p>
                    <div className="text-center m-auto mt-3">
                      <button
                        type="button"
                        className="mainBtn1 "
                        onClick={() => {
                          setUnauthorisedModal(!unauthorisedModal)
                          navigate("/SignIn");
                          localStorage.clear();
                          sessionStorage.removeItem('hasModalShown');
                        }}
                      >
                        {t("modals.login")} 
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }


      {showD && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={(e) => {
                    deleteNoti(e)
                    e.preventDefault(); // Prevents the default behavior (navigation)
                    e.stopPropagation()
                  }}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>


            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

    </>
  );

}
